import { colors } from "pages/Home/Home.styles";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
export const SkeletonSquare = () => {
  return (
    <SkeletonTheme
      baseColor={colors.background}
      highlightColor={colors.whiteOpacity}
    >
      <Skeleton height={"100%"} />
    </SkeletonTheme>
  );
};
